
import { defineComponent, PropType, ref } from "vue";
import Pagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";

export default defineComponent({
  name: "Table",
  props: {
    data: {
      type: Array as PropType<any[]>,
      required: true,
    },
    columns: {
      type: Array as PropType<
        {
          title: string;
          dataIndex: string;
          customRender: string;
        }[]
      >,
      required: true,
    },
    loading: Boolean,
    withPagination: Boolean,
    page: Number,
    pages: Number,
  },
  setup(props, context) {
    const pagePagination = ref(props.page);

    const paginationHandler = (page: number) => {
      context.emit("paginationChange", page);
    };

    return { pagePagination, paginationHandler };
  },
  components: { Pagination },
});
